import { render, staticRenderFns } from "./valveClampDownstream.vue?vue&type=template&id=53339ee0&scoped=true"
import script from "./valveClampDownstream.vue?vue&type=script&lang=js"
export * from "./valveClampDownstream.vue?vue&type=script&lang=js"
import style0 from "./valveClampDownstream.vue?vue&type=style&index=0&id=53339ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53339ee0",
  null
  
)

export default component.exports